import "./index.css";
import Weather from "./Weather";


export default function App() {

  return (     
        <Weather defaultCity="Belo Horizonte" />
  );

}